import { cn } from '@/lib/cn'

type SpinnerProps = {
  className?: string
  /** Announced to screen readers. Pass null when a visible label already says it. */
  label?: string | null
}

export function Spinner({ className, label = 'Loading' }: SpinnerProps) {
  return (
    <span
      className={cn(
        'inline-block size-4 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent',
        className,
      )}
      role={label ? 'status' : undefined}
      aria-label={label ?? undefined}
      aria-hidden={label ? undefined : 'true'}
    />
  )
}

/** Whole-viewport loader used while the session bootstraps and while routes load. */
export function FullPageLoader({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-canvas text-ink-muted">
      <Spinner className="size-6 text-brand-600" label={null} />
      <p aria-live="polite">{label}…</p>
    </div>
  )
}
